import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, ViewContainerRef } from "@angular/core";
import { SharedService } from '../shared';
import { DateneingabeFragebogeCommonComponent } from './dateneingabe-frageboge-common.component';
import { LANGUAGE_ENUM } from "./questionnaire.model";

@Component({
    selector: 'app-dateneingabe-frageboge',
    templateUrl: "./dateneingabe-frageboge.component.html",
    styleUrls: ["./dateneingabe-frageboge.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DateneingabeFragebogeComponent extends DateneingabeFragebogeCommonComponent implements OnInit {
    pageName: string = "dateneingabe";
    LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;


    showLoginPage: boolean = true;
    sidebarExpaned: boolean = true;
    showConfirmation: boolean = false;

    questId: string = "XXX";

    constructor(protected cd: ChangeDetectorRef,
        protected vcr: ViewContainerRef,
        protected sharedService: SharedService) {
        super(cd, vcr, sharedService,);
    }

    ngOnInit(): void {
        const queries = this.sharedService.getUrlVars();
        const dc = queries["dc"];
        const dc_timestamp = queries["dc_timestamp"];
        if (dc && dc_timestamp) {
            this.showLoginPage = false;
            this.cd.detectChanges();
            this.fnLoadQuestionnaire();
        }
    }

    toggleSidebar() {
        this.sidebarExpaned = !this.sidebarExpaned;
    }


    fnSaveDateneingabeData(payload) {
        this.showLoader = true;
        this.sharedService.saveDateneingabeData(payload).subscribe({
            next: (res) => {
                this.questId = res;
                this.showConfirmation = true;
                this.showLoader = false;
            },
            error: (err) => {
                this.showLoader = false;
            }
        });
    }

}
